import { render, staticRenderFns } from "./Create-Enquiry.vue?vue&type=template&id=0cdd350e&scoped=true"
import script from "./Create-Enquiry.vue?vue&type=script&lang=js"
export * from "./Create-Enquiry.vue?vue&type=script&lang=js"
import style0 from "./Create-Enquiry.vue?vue&type=style&index=0&id=0cdd350e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd350e",
  null
  
)

export default component.exports